// removed by extract-text-webpack-plugin
module.exports = {"watermarkContainer":"_26Y1-FJqrsq94ehHsh0kgq","watermarkContent":"_1DLhgx1yRh8bQFRh4eGD1A","warnSign":"zbS3iJJ2foyHHXXN3kIiz","header":"SksiLqgdfnESaVGw0FKup","warningImg":"_2XB2lWBYieBxwIiGs2z_LR","warningContainer":"_1TRpPjjMwznDGXcAXlr0zq","text":"_2TnKXTrJn57TaayGfq9GT4","subheader":"_2MK_daCAAoN0Jgbwg-LFnn","hint":"AKoSkVVXhYI1YoLxnkB1G","warningAnimation":"_1YIpyhU1NGW0pS6KRwA37","warning":"_23uC_baBS4ifFrykpnii8P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/WatermarkWarning/WatermarkWarning.scss
// module id = 1293
// module chunks = 1